import React, {Component, Fragment} from 'react';
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import DEFINE, {PATHS, FEATURE_FLAGS} from "../../../../constants/Define";
import Ripple from '../../common/component/Ripple';
import AmenityList from './AmenityList';
import { Link } from 'react-router-dom';

let permisionActions = [];

export default class Amenities extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.getListAmenities();
    }

    render() {
        const {t, amenityState} = this.props;
        const { isFetching, amenities } = amenityState;
        
        return (
            <Fragment>
                <HMS.PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage}>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'amenities'}
                        titleHeader={t('navigation.amenities')}
                        componentRight={
                            <Fragment>{
                                <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                    <Link to={PATHS.AMENITY.CREATE.path}
                                          className='btn btn-primary'>+ {t(`action.create`)}</Link>
                                </Ripple>
                            }
                            </Fragment>
                        }
                    />
                    <AmenityList loading={isFetching}
                                  permisions={permisionActions}
                                  amenities={amenities}
                                  onDelete={this.onDeleteAmenity}
                                  onChange={this.onTableChange}
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    onChangeLanguage = () => {
        this.props.getListAmenities()
    }

    onTableChange = (pagination, filters, sorter) => {
        // let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        // this.setState({
        //     filters: newFilters
        // });
        this.props.getListAmenities()
    };

    onDeleteAmenity = (item) => {
        this.props.deleteAmenityDetail(item);
    }
}

